module.exports = __webpack_public_path__ + "static/img/six.de5040e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expert/six.png
// module id = t1fu
// module chunks = 0